export const DIESEL_API_ROOT = 'https://api.staging.diesellabs.com'
// export const DIESEL_API_ROOT='http://127.0.0.1:8888'
export const EXTERNAL_API_ROOT='https://api-ext.staging.diesellabs.com'
//export const EXTERNAL_API_ROOT='http://127.0.0.1:9002'
export const OPENAI_API_ROOT='https://api-ai.staging.diesellabs.com'
// export const OPENAI_API_ROOT='http://localhost:8000'
export const DIESEL_AUTH0_CLIENT_ID = 'd20QSaaWZeHGlvsxOaV3fSP5D5W1UJC6'
export const DIESEL_AUTH0_DOMAIN = 'diesel.auth0.com'
export const DIESEL_SEGMENT_WRITE_KEY = 'lGY0TFraWAlCBqNNwjNa69jEqI3tqA6i'

export const PLACEHOLDER_IMG = '/static/images/placeholder.png'
export const LIFESTYLE_PLACEHOLDER = '/static/images/placeholder-lifestyle.png'
export const DIESEL_PLACEHOLDER_IMG = '/static/images/placeholder_dl_logo.png'
export const DIESEL_PLACEHOLDER_GRAY_IMG = '/static/images/dl_placeholder_gray.png'

export const HOMEPAGE = 'homepage'
export const LIBRARY = 'library'
export const MEDIA_PREFERENCE = 'media'
export const BRAND_PREFERENCE = 'brand'
export const DEMOGRAPHICS = 'demographics'
export const TRENDING = 'trending'
export const ANTICIPATION = 'anticipation'
export const MEDIA_PLANNING = 'plan'
export const MEDIA_PLANNING_SHORTCUT = 'Media Planning'
export const TRACKER = 'tracker'
export const DISCOVER_EXPLORE = 'discover'
export const REDISCOVER = 'rediscover'
export const CALENDAR = 'calendar'
export const AUDIENCE_ACQUISITION = 'acquisition'
export const ATTENTION_INDEX = 'attention'
export const GLOBAL_ATTENTION_INDEX = 'attentionindex'
export const DASHBOARD = 'dashboard'
export const SUBSCRIBER_OVERVIEW = 'subscriber'
export const ACQUISITION_ROLLING = 'rolling'
export const ACQUISITION_PREMIERE = 'premiere'
export const BUDGET_SUBSCRIBERS = 'budget'
export const CHAT_BOT = 'chatbot'
export const TRENDING_TOPICS = 'trendingtopics'

export const ACQUISITION = 'Audience Acquisition'
export const MAINTENANCE = 'Audience Maintenance'
export const ACQUISITION_TITLE = 'Shows and movies by new engagers'
export const MAINTENANCE_TITLE = 'Shows and movies by existing engagers'
export const ACQUISITION_HOVER_TITLE = '% of Audience New to Network'
export const MAINTENANCE_HOVER_TITLE = '% of Existing Audience Engaged'

export const MEDIA_ACCESS_GROUP = ['Admin', 'Diesel Internal', 'MediaKitchen']
export const BRAND_ACCESS_GROUP = ['Admin', 'Diesel Internal']
export const DEMO_ACCESS_GROUP = ['Admin', 'Diesel Internal']
export const TRENDING_ACCESS_GROUP = ['Admin', 'Diesel Internal']
export const ANTICIPATION_ACCESS_GROUP = ['Admin', 'Diesel Internal']
export const AUDIENCE_LIMIT = 20
export const RECOMMENDATION_LIMIT = 100

export const CURRENT_FILTER = 'currentFilters'
export const TLM_FILTER = 'tlmFilters'
export const PROGRAMMING_FILTER = 'programmingFilters'
export const GENRE_FILTER = 'genreFilters'
export const BRAND_FILTER = 'brandFilters'
export const OTHER_FILTER = 'otherFilters'
export const MEDIA_TYPE_FILTER = 'mediaTypeFilters'
export const ANTICIPATION_FILTER = 'anticipationFilters'
export const TOPIC_SUBTYPES = 'Movie Show People Brand Music Lifestyle Channel Video Gaming'
export const MEDIA_PREFERENCE_SUBTYPES = 'Movie Show People Brand Music Lifestyle Channel Gaming'

export const FILTER_MODE_NEW = 'new'
export const FILTER_MODE_UPDATE = 'update'

export const TOP_TEN_TRENDING_TITLE = 'Top 10 Trending'
export const TOP_TEN_TRENDING_SUB_TITLE = 'Top trending content across the media landscape'
export const MOST_POPULAR_TRENDING_TITLE = 'Most Popular'
export const MOST_POPULAR_TRENDING_SUB_TITLE = 'Most popular content across the media landscape'
export const TOP_TRENDING = 'Trending'
export const MOST_POPULAR = 'Most Popular'
export const TRENDING_UP = 'Up'
export const TRENDING_DOWN = 'Down'
export const TRENDING_FLAT = 'Flat'

export const LOGIN = 'Login'
export const HOME_PAGE = 'Homepage'
export const HOMEPAGE_GENRE_PROFILE = 'Genre Profile'
export const HOMEPAGE_GENRE_INTEREST = 'Genre Interest'
export const LIBRARY_MODULE = 'Library'
export const MEDIA_PREFERENCE_MODULE = 'Media Preference'
export const BRAND_PREFERENCE_MODULE = 'Brand Preference'
export const DEMOGRAPHICS_MODULE = 'Demographics'
export const TRENDING_MODULE = 'Trending'
export const ANTICIPATION_MODULE = 'Anticipation'
export const LAUNCH_TRACKER = 'Launch Tracker'
export const ENTITY = 'Entity'
export const VIDEO = 'Video'
export const VIDEO_CHANNEL = 'VideoChannel'
export const YOUTUBE = 'YouTube'
export const COMPARE = 'Compare'
export const TRACKER_MODULE = 'Tracker'
export const AUDIENCE_ACQUISITION_MODULE = 'Audience Acquisition'
export const AUDIENCE_DRIVER_MODULE = 'New Audience Drivers'
export const AUDIENCE_LIFT_MODULE = 'Audience Lift'
export const CALENDAR_MODULE = 'Calendar'
export const DISCOVER_EXPLORER = 'Discover Explore'
export const DISCOVER_CONTENT_ANALYSIS = 'Discover Content Analysis'
export const BL = 'Burner Link'
export const DISCOVER = 'Discover'
export const SUBSCRIBER_OVERVIEW_MODULE = 'Catalog Overview'
export const SUBSCRIBER = 'Subscriber'
export const SUBSCRIBER_NETWORK_TYPE_PRIMARY = 'primary'
export const SUBSCRIBER_NETWORK_TYPE_DEFAULT1 = 'defaultOne'
export const SUBSCRIBER_NETWORK_TYPE_DEFAULT2= 'defaultTwo'
export const SUBSCRIBER_SORT_TYPE_PRIMARY = 'primaryNetwork'
export const SUBSCRIBER_SORT_TYPE_DEFAULT1 = 'defaultNetwork1'
export const SUBSCRIBER_SORT_TYPE_DEFAULT2= 'defaultNetwork2'
export const SUBSCRIBER_CONTENT_BUDGET = 'Content Budget'
export const SUBSCRIBER_US_SUBSCRIBERS = 'Global Subscribers'
export const ATTENTION_INDEX_MODULE = 'Attention Index'
export const BUDGET_SUBSCRIBERS_MODULE = 'Budget & Subscribers'
export const SUBSCRIPTION_OPTIONS = 'Subscription Options'
export const SUBSCRIPTION_NOTES = 'Notes'
export const FAQ_MODULE = 'FAQ'

export const ACTIVE ='active'
export const NONE = 'None'

export const DISTRO_VIEW = 'distro'
export const NETWORK_VIEW = 'network'
export const BROADCAST_VIEW = 'broadcast'
export const GENRE_VIEW = 'genre'
export const PLAN_VIEW = 'plan'
export const CUSTOM_VIEW = 'custom'

export const DISTRO_VIEW_STREAMING = 'Streaming'
export const DISTRO_VIEW_CABLE = 'Cable'
export const DISTRO_VIEW_BROADCAST = 'Broadcast'
export const DISTRO_VIEW_PREMIUM = 'Premium'
export const DISTRO_VIEW_MOVIE = 'Movie'
export const DISTRO_VIEW_MOVIES = 'Movies'
export const DISTRO_VIEW_SPORTS = 'Sports'
export const NETWORK_VIEW_NETFLIX = 'Netflix'
export const NETWORK_VIEW_HULU = 'Hulu'
export const NETWORK_VIEW_HBO_MAX = 'HBO Max'
export const NETWORK_VIEW_AMAZON = 'Amazon'
export const NETWORK_VIEW_DISNEY_PLUS = 'Disney+'
export const NETWORK_VIEW_PEACOCK = 'Peacock'
export const NETWORK_VIEW_APPLE_TV_PLUS = 'Apple TV+'
export const BROADCAST_VIEW_ABC = 'ABC'
export const BROADCAST_VIEW_CBS = 'CBS'
export const BROADCAST_VIEW_NBC = 'NBC'
export const BROADCAST_VIEW_FOX = 'FOX'
export const BROADCAST_VIEW_CW = 'CW'
export const BROADCAST_VIEW_Cable = 'Cable'
export const PLAN_VIEW_PLAN = 'Plan'
export const OTHER = 'Other'
export const OTHER_CATEGORIES = 'Cable and Cable,Streaming and Cable,Streaming and Broadcast,Cable and Streaming,Broadcast and Cable and Cable,Premium and Streaming,Broadcast and Streaming,Streaming and Streaming,Science Fiction and Sitcom,Action and Adventure and Science Fiction'
export const REDISCOVER_GENRE = 'Science Fiction,Comedy,Drama,Docuseries,Sitcom,Action and Adventure,Crime Drama,Game Show,Sports,Reality Competition,Documentary,Lifestyle,Kids and Family,Reality'

export const YT_COMPLIANCE = 'YouTube Compliance'

export const AUDIENCE_ACQUISITION_START_DATE = '2018-01-01'

export const CLASSES_TO_REMOVE = 'trackerBody,discoverBody,rediscoverBody'

export const TOPLINE_GENRE='Action and Adventure,Comedy,Crime Drama,Documentary,Docuseries,Drama,Kids and Family,Lifestyle,News,Reality,Reality Competition,Science Fiction,Sitcom,Special,Sports,Talk'

export const TRACKER_ENTITY_TYPE_PRIMARY = 'primary'
export const TRACKER_ENTITY_TYPE_BENCHMARK_ONE = 'benchmarkOne'
export const TRACKER_ENTITY_TYPE_BENCHMARK_TWO = 'benchmarkTwo'
export const TRACKER_ENTITY_TYPE_BENCHMARK_THREE = 'benchmarkThree'
export const TRACKER_ENTITY_TYPE_BENCHMARK_FOUR = 'benchmarkFour'
export const TRACKER_LAUNCH_VIEW = 'Launch View'
export const TRACKER_PRE_POST_VIEW = 'Pre/Post View'
export const TRACKER_TIMELINE_VIEW = 'Timeline View'

export const PREMIERE_DATE= 'premiere_date'
export const NEW_TO_NETWORK= 'new_to_network'
export const NETWORK_AUDIENCE_LIFT= 'network_audience_lift'
export const NA = 'N/A'

export const CONTENT_INTELLIGENCE = 'Content Intelligence'
export const CATALOG_ANALYSIS = 'Catalog Analysis'
export const PERFORMANCE_ANALYSIS = 'Performance Analysis'
export const AI_INSIGHTS = 'AI Insights'

export const TYPE = 'Type'
export const NETWORK = 'Network'
export const GENRE = 'Genre'
export const ENGAGEMENTS = 'Engagements'

export const CATALOG_TITLE = 'title'
export const TITLE_GENRE = 'genre'
export const TITLE_PREMIERE = 'premiere'
export const TITLE_GENRE_RANK = 'rank'

export const FILTER_MODE_MENU = 'menu'
export const FILTER_MODE_RESET = 'reset'
export const FILTER_MODE_APPLY = 'apply'

export const PLAN_AFFINITY = 'score'
export const PLAN_PREMIERE = 'active_date'
export const PLAN_GENRE = 'genre'
export const PLAN_PLATFORM = 'category'
export const PLAN_TYPE = 'topic_subtype'

export const MEDIA_PLANNING_ROLL_OVER_MONTHS = 6
export const MEDIA_PLANNING_TOTAL_MONTHS = 12
export const MEDIA_PLANNING_CALENDAR_CHANNEL_INDEX = 0
export const MEDIA_PLANNING_MONTHS_START_INDEX = 1
export const MEDIA_PLANNING_CALENDAR_CURRENT_YEAR_INDEX = 7

export const ANTICIPATION_INDEX = 'Anticipation Index'
export const TOP_CONTENT_INDEX = 'Top Content Index'
export const TRENDING_INDEX = 'Trending Index'
export const CANCELLED_SHOWS_INDEX = 'Cancelled Shows'

export const ATTENTION_INDEX_NEW = 'Attention Index (new)'
export const ATTENTION_INDEX_TOTAL_ENGAGEMENT = 'score'
export const ATTENTION_INDEX_VIDEO_ENGAGEMENT = 'video_score'
export const ATTENTION_INDEX_NON_VIDEO_ENGAGEMENT = 'non_video_score'

export const TRENDING_TOPICS_BL = 'Trending Topics'
export const TRENDING_TOPICS_TWITTER = 'twitter'
export const TRENDING_TOPICS_YOUTUBE = 'youtube'
export const TRENDING_TOPICS_TIKTOK = 'tiktok'
export const TRENDING_TOPICS_INSTAGRAM = 'instagram'